import { Component, SecurityContext } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { NetworkMessage } from '../network-message/network-message';
import { Database } from '../../providers/database';
import { AuthData } from '../../providers/auth';
import { Translate } from '../../providers/translate';
import { DomSanitizer } from '@angular/platform-browser';
import * as firebase from 'firebase';

@Component({
  selector: 'page-network-profile',
  templateUrl: 'network-profile.html'
})
export class NetworkProfilePage {

	event: any;
	client: any;
	dataProfile:any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, translate: Translate, public toastCtrl: ToastController, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public auth: AuthData, private _sanitizer: DomSanitizer) {
    translate.translateGroup(['¿Está seguro que desea aprobar la solicitud de contacto?', 'Cancelar', 'Continuar', 'Se ha realizado el match correctamente'])
    .then(result => {
      this.textTranslate = result;
    });
		this.client = this.params.get('client');
		this.event = this.params.get('event');
		this.dataProfile = this.params.get('dataProfile')
  }

  sendMessage(){
    this.navCtrl.push(NetworkMessage, {client: this.client, event: this.event, userAddressee: this.dataProfile});
  }

  addContact(profile) {
    let start = "BEGIN:VCARD\nVERSION:3.0";
    let end = "END:VCARD";
    let data = "";
        data += "N:" + profile.name.replace(/\s+/g,";");
        data += "\n";
        data += "FN:" + profile.name;
        data += "\n";
        data += "ORG:" + profile.company;
        data += "\n";
        data += "TITLE:" + profile.position;
        data += "\n";
        data += "TEL;TYPE=CELL:" + profile.telephone;
        data += "\n";
        data += "EMAIL:" + profile.email;
        data += "\n";
        data += "NOTE:" + this.event.title;
        data += "\n";

    let convert = this._sanitizer.sanitize(SecurityContext.HTML, (start + '\n' + data + end));
    window.open("data:text/x-vcard;filename=filename.vcf;charset=utf8," + encodeURIComponent(start + '\n' + data + end));
  }

  match(profile) {
    let loading = this.loadingCtrl.create();

    let alert = this.alertCtrl.create({
      title: this.event.title,
      message: this.textTranslate['¿Está seguro que desea aprobar la solicitud de contacto?'],
      buttons: [
        {
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: data => {}
        },
        {
          text: this.textTranslate['Continuar'],
          handler: data => {
            loading.present();

            this.db.updateData('/Clients/' + this.client.url + '/___NetworkingUsers/' + this.auth.getUser().uid + '/' + profile.id + '/networkingData/stateNetworking', 'match').then(() => {
              this.db.updateData('/Clients/' + this.client.url + '/___NetworkingUsers/' + profile.id + '/' + this.auth.getUser().uid + '/networkingData/stateNetworking', 'match').then(() => {
                let toast = this.toastCtrl.create({
                  message: this.textTranslate['Se ha realizado el match correctamente']
                });

                // Return Increase counter user
                firebase.database().ref().child('/Clients/' + this.client.url + '/Users/' + this.auth.getUser().uid + '/numRequestNetworking').
                transaction(function(currentCount) {
                  return currentCount - 1;
                });

                // Increase counter dashboard
                firebase.database().ref().child('/Clients/' + this.client.url + '/___Dashboard/' + this.event.id + '/numMatchNetworking').
                transaction(function(currentCount) {
                  return currentCount + 1;
                });

                toast.present();
                loading.dismiss();
                this.navCtrl.pop();
              });
            });
          }
        }
      ]
    });
    alert. present();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/network-profile/network-profile.ts